module.exports = __webpack_public_path__ + "static/img/goldvip.7fd34040.png";